export const TAB_BAR_HEIGHT = 49;
